
export default {
  props: {
    player: {
      type: Object,
      required: true,
    },
    team: {
      type: Object,
      required: true,
    },
    side: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: `player`,
    },
  },
  data () {
    return {
    };
  },
  computed: {
    playerStatTypes () {
      const position = this.player.position;
      const config = this.additionalConfig?.match_centre_config;
      const allPositionsStats = config?.lineup_player_stats;
      const positionStats = config?.lineup_player_position_stats?.find(stat => stat.position === position);
      return positionStats ? [...allPositionsStats, ...positionStats.stats] : allPositionsStats;
    },
  },
  methods: {
    getStatName (stat) {
      const statObj = this.getPlayerStat(stat);
      return stat.display_name_override !== ``
        ? stat.display_name_override
        : statObj
          ? statObj.playerStatType?.displayName
          : this.deslugify(this.getPlayerStatKey(stat)); // If no stat in API and no override, use the stat key
    },
    getStatValue (stat) {
      const statObj = this.getPlayerStat(stat);
      return statObj ? statObj.value : 0;
    },
    getPlayerStat (stat) {
      const statKey = this.getPlayerStatKey(stat);
      return this.player.playerStats.find(playerStat => playerStat?.playerStatType?.sourceName === statKey);
    },
  },
};
